module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ep",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("We poets in our youth begin in gladness;")])]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("But thereof comes in the end despondency and madness.")])]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORDSWORTH")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0